function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 16,
  cy: 16,
  r: 16,
  fill: "#4D4DED"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M22.75 25L19.0643 19.2143H24.3571V17.0286H7V19.2143H12.2929L8.60714 25H11.35L15.6786 18.2071L20.0071 25H22.75ZM24.3571 14.9071V12.7214H19.1714L22.8143 7H20.05L15.6786 13.9L11.3071 7H8.54286L12.1857 12.7214H7V14.9286L24.3571 14.9071Z",
  fill: "white"
});

function SvgStx(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStx);
export default __webpack_public_path__ + "static/media/STX.da4831d8b819391d3932fc827c09a0d8.svg";
export { ForwardRef as ReactComponent };